/* ============================================
   SMITH'S BLADES — ARTICLE PAGE JS
   v1.0 | Cronix Solutions
   ============================================ */

(function () {
  'use strict';

  /* ——————————————————————————————————————
     1. READING PROGRESS BAR
     —————————————————————————————————————— */
  var progressBar = document.getElementById('articleProgress');
  var articleContent = document.getElementById('articleContent');

  if (progressBar && articleContent) {
    window.addEventListener('scroll', function () {
      var contentTop = articleContent.offsetTop;
      var contentHeight = articleContent.offsetHeight;
      var windowHeight = window.innerHeight;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      var scrollableDistance = contentHeight - windowHeight;
      var scrolled = scrollTop - contentTop;
      var progress = Math.min(Math.max((scrolled / scrollableDistance) * 100, 0), 100);

      progressBar.style.width = progress + '%';
    }, { passive: true });
  }

  /* ——————————————————————————————————————
     2. TABLE OF CONTENTS
     —————————————————————————————————————— */
  var tocContainer = document.getElementById('articleTOC');

  if (tocContainer && articleContent) {
    var headings = articleContent.querySelectorAll('h2, h3');

    if (headings.length > 0) {
      headings.forEach(function (heading, index) {
        // Add ID if missing
        if (!heading.id) {
          heading.id = 'heading-' + index;
        }

        // Create TOC link
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        link.className = 'article-toc-link';
        if (heading.tagName === 'H3') {
          link.classList.add('article-toc-link-h3');
        }

        link.addEventListener('click', function (e) {
          e.preventDefault();
          var targetId = this.getAttribute('href').substring(1);
          var target = document.getElementById(targetId);
          if (target) {
            var offset = 120;
            var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
          }
        });

        tocContainer.appendChild(link);
      });

      // Highlight active section on scroll
      var tocLinks = tocContainer.querySelectorAll('.article-toc-link');

      window.addEventListener('scroll', function () {
        var scrollPos = window.pageYOffset + 150;

        headings.forEach(function (heading, index) {
          var headingTop = heading.offsetTop;
          var headingBottom = headingTop + heading.offsetHeight;

          if (scrollPos >= headingTop && scrollPos < headingBottom) {
            tocLinks.forEach(function (link) { link.classList.remove('active'); });
            if (tocLinks[index]) {
              tocLinks[index].classList.add('active');
            }
          }
        });
      }, { passive: true });
    } else {
      // No headings found, hide TOC block
      var tocBlock = document.querySelector('.article-toc-block');
      if (tocBlock) {
        tocBlock.style.display = 'none';
      }
    }
  }

  /* ——————————————————————————————————————
     3. COPY LINK BUTTON
     —————————————————————————————————————— */
  var copyBtns = document.querySelectorAll('.article-share-copy');

  copyBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = this.getAttribute('data-url');
      var icon = this.querySelector('i');
      var originalIcon = icon.className;

      // Copy to clipboard
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          // Success feedback
          btn.classList.add('copied');
          icon.className = 'ti ti-check';

          setTimeout(function () {
            btn.classList.remove('copied');
            icon.className = originalIcon;
          }, 2000);
        });
      } else {
        // Fallback for older browsers
        var textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);

        btn.classList.add('copied');
        icon.className = 'ti ti-check';

        setTimeout(function () {
          btn.classList.remove('copied');
          icon.className = originalIcon;
        }, 2000);
      }
    });
  });

  /* ——————————————————————————————————————
     4. SCROLL REVEAL (for related articles)
     —————————————————————————————————————— */
  var blogRevealEls = document.querySelectorAll('.blog-reveal');
  if (blogRevealEls.length > 0) {
    var blogObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('blog-visible');
          blogObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    blogRevealEls.forEach(function (el) {
      blogObserver.observe(el);
    });
  }

})();